import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getFileXlsx } from "../templates/CostUpload/FileReceiver";
import AlertManager from "../shared/Alert/Alert";
import { getAPI, putAPI, deleteAPI } from "../backend/commons";


export const downloadErrorReport = async (fileId, fileName, downloadFile) => {
    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }

    const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwDownload}${fileId}/${downloadFile}`;
    // const deleteUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwDeleteFile}${fileId}`;

    const response = await getAPI(apiUrl, tokenInfo);
    // await fetch(apiUrl, {
    //     method: "GET",
    //     // headers: localDatabaseUrls.temp_headers
    //     headers:
    //     {
    //         Authorization: 'Bearer ' + tokenInfo.id_token,
    //         Principal: tokenInfo.access_token,
    //     },
    // });

     if (response && response.status === 200) {
        const contentDisposition = response.headers.get("Content-Disposition");

        let fileNameFromResponse = fileName; // default
        if (contentDisposition && contentDisposition.includes("filename=")) {
            const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match != null && match[1]) {
                fileNameFromResponse = match[1].replace(/['"]/g, ""); // remove quotes
            }
        }

        await getFileXlsx(fileNameFromResponse, response, downloadFile);
    } else {
        const errorData = await response.json();
        AlertManager.error(errorData.message || response.statusText, { contactSupport: false });
        console.error("Error while downloading the report:", response.statusText);
    }
};

export const fileDelete = async (fileId, fetchUploadHistoryDelete, setGridData) => {

    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }
    
    const deleteUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwDeleteFile}${fileId}`;

   const response = await deleteAPI(deleteUrl, tokenInfo);

    if (response.status === 200 || response.status === 201) {
                // Refetch the data and update the grid
                const updatedGridData = await fetchUploadHistoryDelete();
                setGridData(updatedGridData);

                // Get the success message from the response body, or use a default
                const successData = await response.json();
                const successMessage = successData.message || "File deleted successfully";
                AlertManager.success(successMessage, { contactSupport: false });
            } else {
                // For unsuccessful responses, extract the error message
                const errorData = await response.json();
                const errorMessage = errorData.message || response.statusText || "Error deleting file";
                AlertManager.error(errorMessage, { contactSupport: false });
            }

   
};

export const approveDraft = async (selectedFileId, fetchUploadHistoryDelete, setGridData, handleApproveClose) => {

    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }

 const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.draftToApprove}${selectedFileId}`;

   const response = await putAPI(apiUrl, tokenInfo);

    if (response.status === 200 || response.status === 201) {
                // Refetch the data and update the grid
                const updatedGridData = await fetchUploadHistoryDelete();
                setGridData(updatedGridData);

                // Get the success message from the response body, or use a default
                AlertManager.success("File successfully approved", { contactSupport: false });
            } else {
                // For unsuccessful responses, extract the error message
                AlertManager.error("This action could not be performed", { contactSupport: false });
        handleApproveClose();

            }
        handleApproveClose();


};

export const approveDIDraft = async (selectedFileId, fetchUploadHistoryDelete, setGridData, handleApproveClose) => {

    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }

    const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwDiDraftToApprove}${selectedFileId}`;

    const response = await putAPI(apiUrl, tokenInfo);

    if (response.status === 200 || response.status === 201) {
        const updatedGridData = await fetchUploadHistoryDelete();
        setGridData(updatedGridData);
        AlertManager.success("CJW-DI file successfully approved. Landed cost calculation triggered.", { contactSupport: false });
    } else {
        AlertManager.error("This action could not be performed", { contactSupport: false });
    }
    handleApproveClose();
};

export const fileDIDelete = async (fileId, fetchUploadHistoryDelete, setGridData) => {

    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }

    const deleteUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwDiDeleteFile}${fileId}`;

    const response = await deleteAPI(deleteUrl, tokenInfo);

    if (response.status === 200 || response.status === 201) {
        const updatedGridData = await fetchUploadHistoryDelete();
        setGridData(updatedGridData);

        const successData = await response.json();
        const successMessage = successData.message || "CJW-DI file deleted successfully";
        AlertManager.success(successMessage, { contactSupport: false });
    } else {
        const errorData = await response.json();
        const errorMessage = errorData.message || response.statusText || "Error deleting CJW-DI file";
        AlertManager.error(errorMessage, { contactSupport: false });
    }
};

export const downloadDIErrorReport = async (fileId, fileName, downloadFile) => {
    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }

    const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwDiDownload}${fileId}/${downloadFile}`;

    const response = await getAPI(apiUrl, tokenInfo);

     if (response && response.status === 200) {
        const contentDisposition = response.headers.get("Content-Disposition");

        let fileNameFromResponse = fileName; // default
        if (contentDisposition && contentDisposition.includes("filename=")) {
            const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match != null && match[1]) {
                fileNameFromResponse = match[1].replace(/['"]/g, ""); // remove quotes
            }
        }

        await getFileXlsx(fileNameFromResponse, response, downloadFile);
    } else {
        const errorData = await response.json();
        AlertManager.error(errorData.message || response.statusText, { contactSupport: false });
        console.error("Error while downloading the report:", response.statusText);
    }
};
